module.exports = __webpack_public_path__ + "static/thekitchen-724f873decb8b92db0981251e3d454c6.png";